module.exports = __webpack_public_path__ + "static/media/whitebox.d00f41b1.png";